<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">添加
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" icon="el-icon-refresh" size="small" @click="begin">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="count" label="属性数量"> </el-table-column>
                <el-table-column prop="create_time" label="创建时间"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>


        <!-- 设置 -->
        <el-dialog title="模型设置" :visible.sync="dialoged" top="80px" width="60%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="60px" :rules="rules" class="forms-lines">
                    <el-form-item label="名称" prop="name">
                        <el-input size="small" v-model="forms.name"></el-input>
                    </el-form-item>
                    <div>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="handleadds()">添加</el-button>
                            <el-table :data="forms.tableData" border v-loading="forms.loading">
                                <el-table-column label="属性名称">
                                    <template slot-scope="scope">
                                        <el-input size="small" v-model="scope.row.name"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类型">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.type" placeholder="请选择" size="small">
                                            <el-option v-for="item in forms.options" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="每项数据之间用逗号','做分割">
                                    <template slot-scope="scope">
                                        <el-input size="small" v-model="scope.row.value"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="220">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="small" :disabled="scope.$index==0"
                                            @click="handleUp(scope.$index)">上移
                                        </el-button>
                                        <el-button type="primary" size="small"
                                            :disabled="scope.$index==(forms.tableData.length-1)"
                                            @click="handleDown(scope.$index)">下移
                                        </el-button>
                                        <el-button @click="handleDels(scope.$index)" type="danger" size="small">删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,

                // 
                dialoged: false,
                forms: {
                    name: '',
                    tableData: [],
                    options: [{
                            id: '0',
                            name: '占位符'
                        }, {
                            id: '1',
                            name: '单选框'
                        },
                        {
                            id: '2',
                            name: '复选框'
                        }, {
                            id: '3',
                            name: '下拉框'
                        }, {
                            id: '4',
                            name: '输入框'
                        }
                    ],
                },
                rules: {
                    name: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }]
                },
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/ShopProductsModel/index", {
                        page: that.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 
            handleAdd() {
                let that = this
                that.dialoged = true
                this.forms.tableData = []
                 this.forms.name = ''
                that.eid = '0'
            },
            submited(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let flag = true
                        this.forms.tableData.forEach(element => {
                            if (element.name == '' || element.type == '') {
                                flag = false
                            }
                        });
                        if (!flag) return this.$message.error("请把属性名称和类型填写完整");
                        axios
                            .post("/admin/ShopProductsModel/editor", {
                                id: this.eid,
                                attr: this.forms.tableData,
                                name: this.forms.name
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    this.search()
                                      this.dialoged = false
                                        this.$message('操作成功');
                                } else {
                                    this.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        return false;
                    }
                });
            },
            async handleEdit(row) {
                this.forms.name = ''
                this.forms.tableData = []
                this.dialoged = true
                this.eid = row.id
                await this.getinfo()
            },
            async getinfo() {
                await axios
                    .post("/admin/ShopProductsModel/read", {
                        id: this.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data=response.data.data.data
                         this.forms.name =data.name
                         data.attr.forEach(element => {
                             element.type=element.type.toString()
                         });
                        this.forms.tableData =data.attr
                    })
                    .catch(error => {})
            },
            handleadds() {
                var obj = {
                    id: '0',
                    name: '',
                    type: '',
                    value: ''
                }
                this.forms.tableData.push(obj)
            },
            handleDels(index) {
                this.forms.tableData.splice(index, 1)
            },
            handleUp(index) {
                if (index > 0) {
                    const len = this.forms.tableData[index - 1]
                    this.$set(this.forms.tableData, index - 1, this.forms.tableData[index])
                    this.$set(this.forms.tableData, index, len)
                }
            },
            handleDown(index) {
                if (index < this.forms.tableData.length - 1) {
                    const len = this.forms.tableData[index + 1]
                    this.$set(this.forms.tableData, index + 1, this.forms.tableData[index])
                    this.$set(this.forms.tableData, index, len)
                }
            },
            handleDelete(row){
                 let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/ShopProductsModel/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        },

    };
</script>


<style scoped>
</style>